"use client";
import type { DepictOptions } from "@frend-digital/depict/server";
import { useProducts } from "./ListingContext";
import { rpc } from "#rpc";
import { ViewItemList } from "@/features/gtm";
import { useQuery } from "@tanstack/react-query";

export const ViewDepictItemList = ({
	depictCategory,
	depictOptions,
}: { depictCategory: string; depictOptions: DepictOptions }) => {
	const { firstPage } = useProducts();
	const { data: depictCategoryListing } = useQuery({
		queryKey: ["depict-category-listing", depictCategory],
		queryFn: async () => {
			return await rpc.depict.getCategoryListing({
				cache: true,
				depictCategory,
				depictOptions,
			});
		},
	});

	if (!depictCategoryListing || !firstPage) return null;

	return (
		<ViewItemList
			id={depictCategoryListing?.external_id!}
			name={depictCategoryListing?.title!}
			items={firstPage?.products.map((p) => ({
				item_id: p.sku,
				price: p.priceAsNumber!,
				item_name: p.name,
				quantity: 1,
			}))}
		/>
	);
};
